
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.637 44h-9.31c1.838-2.551 2.833-4.937 2.833-8.106 0-1.177.258-4.813-1.895-3.54-2.08 1.23-3.191 3.682-5.434 4.744-6.06 2.87-11.575-1.375-11.575-7.753 0-4.72 2.707-9.487 7.894-9.487 2.198 0 4.065.975 5.947 2 1.58.862 2.667 1.292 3.257 1.292 1.1 0 1.327-1.368.78-2.123-.309-.378-.957-.874-1.949-1.487-2.577-1.596-4.424-4.574-4.424-7.646C14.761 6.75 19.423 4 24.071 4c4.687 0 9.168 2.849 9.168 7.929 0 2.945-1.662 5.929-4.16 7.487-1.19.742-1.905 1.262-2.14 1.557-.57.71-.434 2.177.778 2.177.566 0 1.593-.424 3.079-1.274 3.081-1.77 7.009-3.03 10.283-.974 2.635 1.657 3.665 5.505 3.665 8.443 0 4.528-2.63 8.673-7.505 8.673-3.405 0-5.738-2.007-7.965-4.355-.731-.778-1.238-1.243-1.522-1.398-2.063-1.117-1.947 2.474-1.947 3.558 0 3.222.886 5.636 2.832 8.177","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    